import React, { useState } from "react";
import "../UiStyle/Faq.css";
import SectionTitle from "../SectionTitle/SectionTitle";

const faqData = [
  {
    question: "Are generic medicines safe and effective?",
    answer: `Yes, absolutely. All the medicines we sell are sourced from reputable and certified Indian manufacturers who follow strict quality standards. The generic medicines have the same active ingredients as their brand-name counterparts, which means they work the same way in your body. We never compromise on safety; every product we ship is carefully checked to ensure it has at least six months before expiration, giving you peace of mind with every order.`,
  },
  {
    question: "How do I check the expiration date of my medicines?",
    answer: `We make sure that every medicine shipped to you has a clearly printed expiration date on the packaging — usually found on the back, side, or bottom of the box or blister pack. 
Before dispatch, our team also checks that all medicines have at least 6 months of shelf life remaining, so you can use them with confidence.
Once your order arrives, simply look at the packaging for a label that says "EXP" followed by the month and year (e.g., EXP 11/2026). If you ever receive a product where the expiration date is unclear or missing, please reach out to us right away at support@chemistforall.com, and we’ll be happy to assist you.`,
  },
  {
    question: "What is Chemist For All?",
    answer: `Chemist For All is your go-to online pharmacy for affordable, high-quality generic medicines delivered right to your doorstep anywhere in the USA. Our mission is simple: to make healthcare more accessible by providing the same trusted medications, just without the brand-name price tags. Whether you're looking for everyday essentials or long-term treatments, we're here to help you save money, save time, and avoid the hassle of traditional pharmacies.`,
  },
  {
    question: "How long will it take to deliver my order?",
    answer: `The orders are delivered within 15 to 20 days from the time they were shipped. Since we ship products directly from India, delivery may take a bit longer than domestic orders, but we promise it’s worth the wait. We keep you informed at every step of the journey from order confirmation to when it was shipped, so you're never left in the dark.`,
  },
  {
    question: "Do you deliver across the USA?",
    answer: `We deliver to all 50 states across the USA. Whether you're in a big city or a small town, we believe everyone deserves access to affordable medicine. Our goal is to make sure no one has to go without the treatment they need, just because of high costs or limited access.`,
  },
  {
    question: "Is Chemist For All a legitimate company?",
    answer: `Yes, Chemist For All is a reputable and genuine internet pharmacy that sells authorized generic medications at reasonable costs. We source our medicines from certified Indian manufacturers known for their quality and safety standards. To guarantee your safety, we include easy-to-follow usage instructions and descriptions for every one of our products. 
Our dedicated customer support team is here to help, You can reach us anytime via email at support@chemistforall.com. Once we receive your order details, your medicines are carefully packed and shipped to your doorstep. We’re committed to making healthcare safe, accessible, and stress-free for everyone across the USA.`,
  },
  {
    question: "Do I need a prescription to order?",
    answer: `Yes, if you're ordering prescription medicines, you can either upload your prescription directly during the checkout page or email it to us. This helps us make sure you’re getting the right medications.
For over-the-counter medicines (OTC), you don’t need a prescription, you can order them directly from our website anytime.`,
  },
  {
    question: "Can I pay by E-Checks?",
    answer: `Yes, we currently accept major credit and debit cards, as well as e-checks through a secure payment gateway. All transactions are encrypted and processed safely. Your payment information is never stored or shared with anyone, so you can shop with complete confidence.`,
  },
  {
    question: "Is my personal and payment information safe with you?",
    answer: `Yes, protecting your privacy and security is a top priority for us. We work with trusted payment providers that meet the highest standards of data encryption and fraud protection. We never sell or share your details, and our internal systems are regularly monitored to prevent unauthorized access. If you ever have a question or concern, our dedicated support team is just an email away at support@chemistforall.com.`,
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="container">
      <div className="col-lg-8">
        <SectionTitle sTitle={"Frequently Asked Questions"} />
      </div>
      {faqData.map((item, index) => (
        <div
          className={`faq-item ${openIndex === index ? "open" : ""}`}
          key={index}
          onClick={() => toggleFAQ(index)}
        >
          <div className="faq-question">
            <span className="arrow-icon">&#9656;</span>
            {item.question}
          </div>
          {openIndex === index && (
            <div className="faq-answer">{item.answer}</div>
          )}
        </div>
      ))}
    </div>
  );
} 
